import React from "react";
import ClientLogosWrapper from "@components/ClientLogosMarquee";
import Image from "next/image";

const ClientLogosArabic: React.FC = () => {
    const clientLogosData = ["nas.png", "digi.png", "dubai.png", "hh.png", "800.png", "smoky.png"];
    const clientLogosDataLine2 = ["marg.png", "alila.png", "legend.png", "lux.png", "genius.png", "meydan.png", "trade.png"];
    const clientLogosDataLine3 = ["lads.png", "mob.png", "love.png", "big.png", "best.png", "tvs.png", "tag.png"];

    return (
        <>
            <div className=" mx-auto client-logos py-6 ">
                <h2 className="title">موثوق به من قبل أكثر من 10,000 شركة</h2>

                <div className="logos-wrapper logo-desktop  w-fit mx-auto">
                    {clientLogosData.map((data) => (
                        <div key={data} className="flex items-center justify-center">
                            <Image width={100} height={50} src={`https://assets.gallabox.com/gb-home/client-logos-arabic/${data}`} alt="logo-list" className="w-full" />
                        </div>
                    ))}
                </div>
                <div
                    className="logos-wrapper logo-desktop second-row-logos mt-5 mx-auto w-fit"
                    style={{
                        marginTop: 0,
                    }}
                >
                    {clientLogosDataLine2.map((data) => (
                        <div key={data} className="flex items-center justify-center">
                            <Image width={100} height={50} src={`https://assets.gallabox.com/gb-home/client-logos-arabic/${data}`} alt="logos-list-2" className="w-full" />
                        </div>
                    ))}
                </div>
                <div
                    className="logos-wrapper logo-desktop second-row-logos mt-5 mx-auto w-fit"
                    style={{
                        marginTop: 0,
                    }}
                >
                    {clientLogosDataLine3.map((data) => (
                        <div key={data} className="flex items-center justify-center">
                            <Image width={100} height={50} src={`https://assets.gallabox.com/gb-home/client-logos-arabic/${data}`} alt="logos-list-3" className="w-full" />
                        </div>
                    ))}
                </div>

                <div className="logo-mobile">
                    <ClientLogosWrapper />
                </div>
            </div>
        </>
    );
};

export default ClientLogosArabic;
